import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import { RepoFile } from "types/generated";

const LastCommitCell = ({ item, ...cellProps }: TableSimpleCellProps<RepoFile>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {item.commit.message ? (
        <TableCellText>{item.commit.message}</TableCellText>
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default LastCommitCell;
